"use strict";Object.defineProperty(exports, "__esModule", {value: true});/* "FormChanged" socket notices, fanned out to whoever is showing a form. */



const listeners = new Set()

 const onFormChanged = (listener) => {
  listeners.add(listener)
  return () => { listeners.delete(listener) }
}; exports.onFormChanged = onFormChanged

 const emitFormChanged = (notice) => {
  listeners.forEach(listener => {
    try { listener(notice) } catch (e) { /* one screen's error never stops the others */ }
  })
}; exports.emitFormChanged = emitFormChanged
